import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../lifeStageMappingAction';
import fetchApi from "./fetchApi";

function fetchLifeStageMappingAction() {
  return fetchApi('/v1/fc_api/life_stage_mapping_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchLifeStageMappingAction;
